import React from "react";
import { useTranslation } from "react-i18next";

const BackCard = ({ data, color, productData = {} }) => {
 const { t } = useTranslation();
  const product = productData?.product_details || {};
  const stones = product?.Stones || [];
  const groupedStones = stones.reduce((acc, stone) => {
    const code = stone?.stone_code;
    if (!code) return acc;
    if (!acc[code])
      acc[code] = { pcs: 0, cts: 0, shape: stone?.shape_code || "" };
    acc[code].pcs += Number(stone?.Pcs || 0);
    acc[code].cts += Number(stone?.Cts || 0);

    return acc;
  }, {});

  const stoneObj = Object.entries(groupedStones)
    // .slice(0, 5)
    .map(([code, d]) => `${d.pcs} ${code} ${d.shape} ${d.cts.toFixed(2)} c`);

  const stoneCertificate = (product?.Stones || [])
    // .slice(0, 5)
    .map(
      (stone) =>
        `${stone?.certificate?.type || ""} ${stone?.certificate?.number || ""}`,
    );

  const formatDate = (raw) => {
    if (!raw) return "";
    if (raw.includes("/")) {
      const [dd, mm, yyyy] = raw.split("/");

      return `${dd}/${mm}/${yyyy} : 00:00:00`;
    }

    const d = new Date(raw);

    if (isNaN(d.getTime())) return "";

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} : ${hh}:${min}`;
    // :${ss}
   
  };
  return (
    <div
      style={{
        width: 320,
        height: 204,
        borderRadius: 12,
        backgroundColor: color,
        boxShadow: "0 6px 24px rgba(0,0,0,0.22), 0 1px 4px rgba(0,0,0,0.12)",
        display: "flex",
        flexDirection: "column",
        padding: "14px",
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
        transition: "background-color 0.25s ease",
      }}
    >
      {/* shimmer overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 55%)",
          pointerEvents: "none",
        }}
      />

      {/* Top section */}
      <div style={{ zIndex: 1 }}>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: "#fff",
            textTransform: "uppercase",
            lineHeight: "18px",
          }}
        >
          {t(data.backTitle || "BACK CARD TITLE")}
        </div>

        {/* Serial No. + Model No. */}
        <div style={{ display: "flex", gap: 8, margin: "6px 0px" }}>
          {[
            { lbl: "Serial No.", value: product?.stock_id },
            { lbl: "Model No.", value: product?.SKU },
          ].map(({ lbl, value }) => (
            <div key={lbl} style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 6,
                  color: "#fff",
                  textTransform: "uppercase",
                  lineHeight: "9px",
                }}
              >
                {t(lbl)}
              </div>
              <div
                style={{
                  height: 16,
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: 4,
                }}
              >
                <span style={{ fontSize: 6, color: "#000", lineHeight: "9px" }}>
                  {t(value || "")}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Date of Purchase */}
        <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 6,
                color: "#fff",
                textTransform: "uppercase",
                lineHeight: "9px",
              }}
            >
              {t("Date of Purchase")}
            </div>
            <div style={{ height: 16, background: "#fff" }}>
              <span
                style={{
                  fontSize: 6,
                  color: "#000",
                  lineHeight: "9px",
                  display: "block",
                  padding: "2px 4px",
                }}
              >
                {product?.transaction_date
                  ? formatDate(product?.transaction_date)
                  : formatDate(productData?.transaction_date_raw)}
              </span>
            </div>
          </div>
        </div>

        {/* Product Details */}
        <div
          style={{
            fontSize: 6,
            color: "#fff",
            textTransform: "uppercase",
            lineHeight: "9px",
          }}
        >
          {t("Product Details")}
        </div>
        <div style={{ height: 48, background: "#fff" }}>
          <span
            style={{
              fontSize: 6,
              color: "#000",
              lineHeight: "9px",
              display: "block",
              padding: "2px 4px",
            }}
          >
            <span className="truncate-1-lines" >
               {product?.name && (
              <>
                {product.name}
                <br />
              </>
            )}

            </span>
           <span className="truncate-1-lines">

            {(product?.Metal_code || product?.GrossWt) && (
              <>
                {[
                  product?.Metal_code,
                  product?.GrossWt ? `${product.GrossWt}g` : null,
                  stoneObj.length ? stoneObj.join(", ") : null,
                ]
                  .filter(Boolean)
                  .join(" ")}
                <br />
              </>
            )}
           </span>
           <span className="truncate-2-lines">

            {stoneCertificate.filter((s) => s.trim()).join(", ")}<br/>
           </span>
    <span className="truncate-1-lines">

            {productData?.servies?.filter((s) => s.trim()).join(", ")}<br/>
           </span>
          </span>
        </div>
      </div>

      {/* Footer */}
      <div style={{ zIndex: 1 }}>
        <div
          style={{
            fontSize: 6,
            color: "#fff",
            lineHeight: "9px",
            textAlign: "center",
          }}
        >
          {t(data.footer1 || "Footer Title Line 1")}
        </div>
        <div
          style={{
            fontSize: 6,
            color: "#fff",
            lineHeight: "9px",
            textAlign: "center",
          }}
        >
          {t(data.footer2 || "Footer Title Line 2")}
        </div>
        <div
          style={{
            fontSize: 4,
            color: "#fff",
            lineHeight: "6px",
            textAlign: "center",
            marginTop: 5,
          }}
        >
          {t(data.footerSub || "Footer Subtitle")}
        </div>
      </div>
    </div>
  );
};

export default BackCard;
